import { boolean, defineAction, object } from '~/prix'
import attendanceRefreshViewsAction from './attendanceRefreshViews.action.json' assert { type: 'json' }

const attendanceRefreshViewsActionDefinition = defineAction({
  ...attendanceRefreshViewsAction,
  input: object({}),
  output: object({
    ok: boolean(),
  }),
})

export default attendanceRefreshViewsActionDefinition
